import {
  courseCf7,
  sideCartInit,
  offlineCourseBeneficiarToggle,
  offlineCourseLocation,
  accordeon,
} from './components/index';

const RcProduct = {
  init() {
    courseCf7();
    sideCartInit();
    offlineCourseBeneficiarToggle();
    offlineCourseLocation();
    accordeon();
  }
};

export default RcProduct;

RcProduct.init();
